import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LandingComponent } from './core/components/landing/landing.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { MainComponent } from './core/components/main/main.component';
import { PrivacyStatementPageComponent } from './core/components/privacy-statement-page/privacy-statement-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('src/app/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'app',
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'landing',
        pathMatch: 'full',
      },
      {
        path: 'landing',
        component: LandingComponent,
        canActivate: [AuthGuard],
        data: {},
      },
      {
        path: 'production-planning',
        loadChildren: () => import('src/app/tools/production-planning.module').then((m) => m.ProductionPlanningModule),
        data: { role_privilege: 'production_planning' },
      },
      {
        path: 'privacy',
        component: PrivacyStatementPageComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Privacy' },
      },
      {
        path: '**',
        component: PageNotFoundComponent,
        data: { breadcrumb: 'Not Found' },
      },
    ],
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
